module.exports = __webpack_public_path__ + "static/media/team3.400f4156.jpg";